import { message } from 'src/antd';
import React from 'react';
import { T } from '@transifex/react';
import axios from 'axios';

import { mutateSendVerificationCode } from './sendVerificationCode';
import { mutateVertifyCode } from './verifyCode';
import { mutateUpdateContainers } from './updateContainers';
import { APIError } from '../consts/error';

type TVariables = {
  token: string;
  propertyId: string;
  verificationId: string;
};

const callGetAllNotificationContainers = ({
  token,
  propertyId,
  verificationId,
}: TVariables) => {
  return axios
    .get(
      `notifications/containers?verification_id=${verificationId}&property_id=${propertyId}`,
      {
        headers: {
          'X-API-Key': token,
        },
      }
    )
    .catch((e) => {
      if (e?.response?.data?.detail === 'Forbidden') {
        message.error(<T _str="Verification code expired" />);
        throw new APIError(e?.message, { ERROR_MESSAGE_HANDLED: true });
      } else if (e?.response?.data?.message) {
        message.error(e.response.data.message);
        throw new APIError(e.response.data.message);
      } else {
        throw new APIError(e);
      }
    });
};

export const apiNotification = {
  mutateSendVerificationCode,
  callGetAllNotificationContainers,
  mutateVertifyCode,
  mutateUpdateContainers,
};
